import React from 'react';
import axios from 'axios';
import { Button, Form, Input, Segment, Grid, Loader } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { loadPlaceLKPS } from '../../../reduxFiles/placeLKPSActions';


class EditMobility extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mobility: this.props.mobility,
            name: this.props.mobility.universityName,
            nameEn: this.props.mobility.translations.filter((e) => e.language === 'en')[0] ? this.props.mobility.translations.filter((e) => e.language === 'en')[0].universityName : null,
            nameOther: this.props.mobility.translations.filter((e) => e.language !== 'en')[0] ? this.props.mobility.translations.filter((e) => e.language !== 'en')[0].universityName : this.props.mobility.translations.filter((e) => e.language === 'en' && e.originalLanguage === true)[0] ? this.props.mobility.translations.filter((e) => e.language === 'en' && e.originalLanguage === true)[0].universityName : null,
            // nameOther: this.props.mobility.translations.filter((e) => e.language !== 'en')[0] ? this.props.mobility.translations.filter((e) => e.language !== 'en')[0].universityName : null,
            faculty: this.props.mobility.facultyName,
            facultyEn: this.props.mobility.translations.filter((e) => e.language === 'en')[0] ? this.props.mobility.translations.filter((e) => e.language === 'en')[0].facultyName : null,
            facultyOther: this.props.mobility.translations.filter((e) => e.language !== 'en')[0] ? this.props.mobility.translations.filter((e) => e.language !== 'en')[0].facultyName : this.props.mobility.translations.filter((e) => e.language === 'en' && e.originalLanguage === true)[0] ? this.props.mobility.translations.filter((e) => e.language === 'en' && e.originalLanguage === true)[0].facultyName : null,
            country: this.props.mobility.country.id,
            academicYear: this.props.mobility.semester.academicYear.id,
            semester: this.props.mobility.semester.id,
            semesterNum: this.props.mobility.studyProgramSemester.id,
            student: JSON.parse(localStorage.getItem('student')),
            translations: this.props.mobility.translations,
            original: this.props.mobility.translations[0].originalLanguage,
            semesterOptions: [],
            otherLangOptions: [],
            // otherLang: this.props.mobility.translations.filter((e) => e.language !== 'en')[0] ? this.props.mobility.translations.filter((e) => e.language !== 'en')[0].language : null,
            otherLang: this.props.mobility.translations.filter((e) => e.originalLanguage === true)[0] ? this.props.mobility.translations.filter((e) => e.originalLanguage === true)[0].language : null,

            nameErr: false,
            nameEnErr: false,
            nameOtherErr: false,
            facultyErr: false,
            countryErr: false,
            academicYearErr: false,
            semesterErr: false,
            semesterNumErr: false,

        };
        this.editMobility = this.editMobility.bind(this);
        this.closeEditMode = this.closeEditMode.bind(this);
        this.fetchAcademicYearOptions = this.fetchAcademicYearOptions.bind(this);
        this.fetchSemesterOptions = this.fetchSemesterOptions.bind(this);
        this.fetchLangOptions = this.fetchLangOptions.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        if (!this.props.placeLKPS.loaded && !this.props.placeLKPS.loading) {
            this.props.loadPlaceLKPS();
        }
        this.fetchAcademicYearOptions();
        this.fetchSemesterOptions(this.props.mobility.semester.academicYear.id);
        this.fetchLangOptions();

        axios.get('/study-program-semesters')
            .then(res => {
                this.setState({
                    semesterNumOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }))
                });
            });
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.mobility !== this.state.mobility) {
            this.fetchSemesterOptions(this.props.mobility.semester.academicYear.id);
            this.setState({
                mobility: this.props.mobility,
                name: this.props.mobility.universityName,
                country: this.props.mobility.country.id,
                academicYear: this.props.mobility.semester.academicYear.id,
                semester: this.props.mobility.semester.id,
                semesterNum: this.props.mobility.studyProgramSemester.id,
                original: this.props.mobility.translations.filter((e) => e.language !== 'en')[0].originalLanguage,
                nameEn: this.props.mobility.translations.filter((e) => e.language === 'en')[0] ? this.props.mobility.translations.filter((e) => e.language === 'en')[0].universityName : null,
                nameOther: this.props.mobility.translations.filter((e) => e.language !== 'en')[0] ? this.props.mobility.translations.filter((e) => e.language !== 'en')[0].universityName : this.props.mobility.translations.filter((e) => e.language === 'en' && e.originalLanguage === true)[0] ? this.props.mobility.translations.filter((e) => e.language === 'en' && e.originalLanguage === true)[0].universityName : null,
                // nameOther: this.props.mobility.translations.filter((e) => e.language !== 'en')[0] ? this.props.mobility.translations.filter((e) => e.language !== 'en')[0].universityName : null,
                facultyEn: this.props.mobility.translations.filter((e) => e.language === 'en')[0] ? this.props.mobility.translations.filter((e) => e.language === 'en')[0].facultyName : null,
                facultyOther: this.props.mobility.translations.filter((e) => e.language !== 'en')[0] ? this.props.mobility.translations.filter((e) => e.language !== 'en')[0].facultyName : this.props.mobility.translations.filter((e) => e.language === 'en' && e.originalLanguage === true)[0] ? this.props.mobility.translations.filter((e) => e.language === 'en' && e.originalLanguage === true)[0].facultyName : null,
                // facultyOther: this.props.mobility.translations.filter((e) => e.language !== 'en')[0] ? this.props.mobility.translations.filter((e) => e.language !== 'en')[0].facultyName : null,
                otherLang: this.props.mobility.translations.filter((e) => e.originalLanguage === true)[0] ? this.props.mobility.translations.filter((e) => e.originalLanguage === true)[0].language : null,
                // otherLang: this.props.mobility.translations.filter((e) => e.language !== 'en')[0] ? this.props.mobility.translations.filter((e) => e.language !== 'en')[0].language : null,
                // otherLang: this.state.mob.translations.filter((e) => e.originalLanguage === true)[0].language
            });
        }
    }

    fetchLangOptions() {
        axios.get('/languages')
            .then(res => {
                this.setState({
                    otherLangOptions: res.data.map(el => ({
                        key: el.twoLetterCode,
                        value: el.twoLetterCode,
                        text: el.name
                    }))
                });
            });
    }

    fetchAcademicYearOptions() {
        axios.get('/academic-years/current-and-previous/')
            .then(res => {
                this.setState({
                    academicYearOptions: res.data.reverse().map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }))
                });
            });
    }

    fetchSemesterOptions(academicYearId) {
        axios.get(`semester/by-academic-year/${academicYearId}/`)
            .then(res => {
                this.setState({
                    semesterOptions: res.data.map(el => ({
                        ...el, key: el.name._key, value: el.id, text: el.name.name
                    }))
                });
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'academicYear') { this.setState({ semester: null }); this.fetchSemesterOptions(value); }
        this.setState({
            [name]: value
        });
    }

    closeEditMode() {
        this.props.closeEditMode();
    }

    editMobility(
        universityName,
        country,
        studyProgramSemester,
        academicYear,
        semester,
        faculty
    ) {
        if (!this.state.name || !this.state.semester || !this.state.academicYear || !this.state.semesterNum
            || !this.state.country || !this.state.faculty || !this.state.otherLang || !this.state.nameOther || !this.state.facultyOther) {
            if (!this.state.nameOther) {
                toast('Niste unijeli sve podatke. Prevod na izvorni jezik je obavezan!');
            } else { toast('Niste unijeli sve podatke'); }
            if (!this.state.name) { this.setState({ nameErr: true }); } else { this.setState({ nameErr: false }); }
            if (!this.state.country) { this.setState({ countryErr: true }); } else { this.setState({ countryErr: false }); }
            if (!this.state.faculty) { this.setState({ facultyErr: true }); } else { this.setState({ facultyErr: false }); }
            if (!this.state.otherLang) { this.setState({ otherLangErr: true }); } else { this.setState({ otherLangErr: false }); }
            if (!this.state.nameOther) { this.setState({ nameOtherErr: true }); } else { this.setState({ nameOtherErr: false }); }
            if (!this.state.facultyOther) { this.setState({ facultyOtherErr: true }); } else { this.setState({ facultyOtherErr: false }); }
            if (!this.state.semester) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
            if (!this.state.academicYear) { this.setState({ academicYearErr: true }); } else { this.setState({ academicYearErr: false }); }
            if (!this.state.semesterNum) { this.setState({ semesterNumErr: true }); } else { this.setState({ semesterNumErr: false }); }
            if (!this.state.nameEn && this.state.facultyEn) { this.setState({ nameEnErr: true }); }
            if (this.state.nameEn && !this.state.facultyEn) { this.setState({ facultyEnErr: true }); }
        } else {
            this.setState({ loader: true });
            let { optLock } = this.props.mobility;
            let id = this.props.mobility.id;
            let studentStudyProgram = { id: this.state.student.id };
            let translations = [];
            if ((this.state.nameEn || this.state.facultyEn) && this.state.otherLang !== 'en') {
                translations.push({
                    language: { twoLetterCode: (this.state.otherLangOptions.filter((e) => e.value === 'en') ? this.state.otherLangOptions.find((e) => e.value === 'en').value : null) },
                    // language: { twoLetterCode: 'en' },
                    universityName: this.state.nameEn,
                    facultyName: this.state.facultyEn,
                    originalLanguage: 0,
                });
            }
            if (this.state.nameOther || this.state.facultyOther) {
                translations.push({
                    language: { twoLetterCode: this.state.otherLang },
                    universityName: this.state.nameOther,
                    facultyName: this.state.facultyOther,
                    originalLanguage: this.state.original,
                });
            }

            let createMarkObj = {
                id,
                optLock,
                studentStudyProgram,
                universityName,
                facultyName: this.state.faculty,
                country: { id: this.state.country },
                studyProgramSemester: { id: this.state.semesterNum },
                semester: { id: this.state.semester },
                translations: [...translations]
            };

            axios.put('student-study-program-mobility/edit/', { ...createMarkObj })
                .then(res => {
                    toast('Izmjena mobilnosti je uspješno izvršena.');
                    this.setState({ loader: false });
                    this.props.getMobility();
                    this.props.closeEditMode();
                })
                .catch(err => {
                    if (err.response.data === 'This data has been changed!') {
                        toast('Podaci o mobilnosti su već izmijenjeni!');
                    }
                    if (err.response.data === 'Mobility information for this semester is already added!') {
                        toast('Podaci o mobilnosti za ovaj semestar su već dodani!');
                    } else {
                        toast('Došlo je do greške! Studentu nije izmijenjena mobilnost.');
                    }
                });
        }
    }

    render() {
        if (this.props.placeLKPS.error) return <div>ERROR </div>;
        if (!this.props.placeLKPS.loaded) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        const { countries } = this.props.placeLKPS;
        if (this.state.error) return <div>Greška</div>;
        return (
            <div>
                <Segment.Group secondary>
                    <Segment secondary>
                        <Form noValidate>
                            <Grid columns={2} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Form.Field
                                            required
                                            control={Input}
                                            label="Univerzitet"
                                            value={this.state.name}
                                            onChange={(e) => this.setState({ name: e.target.value })}
                                            name="name"
                                            placeholder="Unesite naziv univerziteta"
                                            error={this.state.nameErr}
                                        />
                                        <Form.Field
                                            required
                                            control={Input}
                                            label="Univerzitet (engleski jezik)"
                                            value={this.state.nameEn}
                                            onChange={(e) => this.setState({ nameEn: e.target.value })}
                                            name="nameEn"
                                            placeholder="Unesite naziv univerziteta"
                                            error={this.state.nameEnErr}
                                            disabled={this.state.otherLang === 'en'}
                                        />
                                        <Form.Field
                                            required
                                            control={Input}
                                            label="Fakultet/akademija"
                                            value={this.state.faculty}
                                            onChange={(e) => this.setState({ faculty: e.target.value })}
                                            name="faculty"
                                            placeholder="Unesite naziv fakulteta/akademije"
                                            error={this.state.facultyErr}
                                        />
                                        <Form.Field
                                            control={Input}
                                            label="Fakultet/akademija (engleski jezik)"
                                            value={this.state.facultyEn}
                                            onChange={(e) => this.setState({ facultyEn: e.target.value })}
                                            name="facultyEn"
                                            placeholder="Unesite naziv fakulteta/akademije"
                                            error={this.state.facultyEnErr}
                                            disabled={this.state.otherLang === 'en'}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Segment>
                                            <Form.Field error={this.state.otherLangErr} required>
                                                <label>Izvorni jezik</label>
                                                <Form.Dropdown
                                                    clearable
                                                    selection
                                                    placeholder="Odaberite izvorni jezik"
                                                    value={this.state.otherLang}
                                                    onChange={this.handleInputChange}
                                                    name="otherLang"
                                                    // options={this.state.otherLangOptions.filter((e) => (e.value === this.state.mob.translations.filter((e) => e.originalLanguage === true)[0].language))}
                                                    options={this.state.otherLangOptions.filter((e) => (e.value !== 'bs'))}
                                                    // options={this.state.otherLangOptions.filter((e) => (e.value !== 'en' && e.value !== 'bs'))}
                                                    search
                                                    fluid
                                                />
                                            </Form.Field>
                                            <Form.Field
                                                required
                                                control={Input}
                                                label="Univerzitet (izvorni jezik)"
                                                value={this.state.nameOther}
                                                onChange={(e) => this.setState({ nameOther: e.target.value })}
                                                name="nameOther"
                                                placeholder="Unesite naziv univerziteta"
                                                error={this.state.nameOtherErr}
                                            />
                                            <Form.Field
                                                required
                                                control={Input}
                                                label="Fakultet/akademija (izvorni jezik)"
                                                value={this.state.facultyOther}
                                                onChange={(e) => this.setState({ facultyOther: e.target.value })}
                                                name="facultyOther"
                                                placeholder="Unesite naziv fakulteta/akademije"
                                                error={this.state.facultyOtherErr}
                                            />
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <Grid columns={4} centered className="stackable">
                                <Grid.Row stretched>
                                    <Grid.Column>
                                        <Form.Field required>
                                            <label>Država</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite državu"
                                                value={this.state.country}
                                                onChange={this.handleInputChange}
                                                name="country"
                                                options={countries}
                                                search
                                                fluid
                                                error={this.state.countryErr}
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field required error={this.state.academicYearErr}>
                                            <label>Akademska godina</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite akademsku godinu"
                                                value={this.state.academicYear}
                                                onChange={this.handleInputChange}
                                                name="academicYear"
                                                options={this.state.academicYearOptions}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field required error={this.state.semesterErr}>
                                            <label>Semestar</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite semestar"
                                                value={this.state.semester}
                                                onChange={this.handleInputChange}
                                                name="semester"
                                                options={this.state.semesterOptions.filter(e => e.name._key !== 'other')}
                                                disabled={!this.state.academicYear}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Form.Field required error={this.state.semesterNumErr}>
                                            <label>Broj semestra</label>
                                            <Form.Dropdown
                                                clearable
                                                selection
                                                placeholder="Odaberite semestar"
                                                value={this.state.semesterNum}
                                                onChange={this.handleInputChange}
                                                name="semesterNum"
                                                options={this.state.semesterNumOptions}
                                                search
                                                fluid
                                            />
                                        </Form.Field>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <br />

                            <Button color="blue" basic="true" floated="right" onClick={this.closeEditMode}>Odustani</Button>
                            <Button
                                color="blue"
                                floated="right"
                                onClick={() => this.editMobility(
                                    this.state.name,
                                    this.state.country,
                                    this.state.semesterNum,
                                    this.state.academicYear,
                                    this.state.semester,
                                    this.state.faculty
                                )}
                            >
                                Sačuvaj izmjene
                            </Button>
                            <br />
                            <br />
                        </Form>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}

const mapStateToProps = ({ placeLKPS }) => ({ placeLKPS });
export default connect(mapStateToProps, { loadPlaceLKPS })(EditMobility);




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/EditMobility.js